import {
    USE_BRANDING,
    SET_BRANDING,
} from "./actionType";

export const useBranding = () => {
    return {
        type: USE_BRANDING,
    };
};

export const setBranding = (branding) => {
    return {
        type: SET_BRANDING,
        payload: branding,
    };
};
